import {connect} from 'react-redux';
import {AccountWidget} from '@techsmith/tsc-cloud-style-guide';
import UserModel from '../../types/UserModel';
import Config from '../../globals/Config';
import Constants from '../../globals/Constants';
import ReduxState from '../../types/ReduxState';
import UserService from '../../services/UserService/UserService';

const mapStateToProps = (state: ReduxState, ownProps: AccountWidgetContainerProps): any => {
   const user = Config.user.isAuthenticated && state.currentUser ? state.currentUser : {} as UserModel;

   return {
      isSignedIn: !!user.userId,
      hideSigninButton: !ownProps.showSigninButton,
      userDisplayName: user.name || '',
      userEmail: user.email || '',
      userID: user.userId || null,
      avatarImageUrl: UserService.returnAvatarUrlIfNotDefault(user.avatarUrl),
      signInUrl: Constants.siteLinks.signin,
      myAccountUrl: Config.myAccountUrl,
      signOutUrl: Constants.siteLinks.signout,
      testId: 'account-widget',
      themeName: state.themeName
   };
};

interface AccountWidgetContainerProps {
   showSigninButton?: boolean;
}

export default connect(mapStateToProps)(AccountWidget);
